import React, { useState } from "react";
import SectionShell from "../layout/SectionShell";
import { skillsData } from "../../mock/portfolioData";
import { Badge } from "../ui/badge";

export function SkillsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeCategory = skillsData.categories[activeIndex];

  return (
    <SectionShell id="skills" title="Skills" kicker="Capabilities">
      <div className="grid gap-8 md:grid-cols-[minmax(0,1.2fr)_minmax(0,1.6fr)]">
        <div className="space-y-3">
          <p className="text-sm text-slate-300">
            A blend of AI, search, backend, and frontend skills that helps me own
            projects from problem definition to production deployment.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {skillsData.categories.map((cat, index) => (
              <button
                key={cat.name}
                type="button"
                onClick={() => setActiveIndex(index)}
                className={`rounded-full border px-3 py-1 text-xs font-mono font-medium tracking-[0.08em] transition-colors ${
                  index === activeIndex
                    ? "border-cyan-400 bg-slate-950 text-cyan-100 shadow-[0_0_18px_rgba(34,211,238,0.45)]"
                    : "border-slate-700 bg-slate-900 text-slate-300 hover:border-cyan-400/70 hover:text-cyan-100"
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>
        <div className="space-y-3 rounded-2xl border border-slate-800 bg-slate-900/60 p-5">
          <h3 className="text-sm font-semibold text-slate-50">
            {activeCategory.name}
          </h3>
          <p className="text-xs text-slate-300">{activeCategory.description}</p>
          <div className="mt-3 flex flex-wrap gap-2">
            {activeCategory.skills.map((skill) => (
              <Badge
                key={skill}
                variant="outline"
                className="border-cyan-400/60 bg-slate-950 text-[11px] font-mono font-medium tracking-[0.08em] text-cyan-100"
              >
                {skill}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </SectionShell>
  );
}

export default SkillsSection;
